import { inject } from 'mobx-react';
import { LayoutComponent } from './component';
export const Layout = inject(({ ui, auth, mfeManager, tenant, userProfile }) => ({
    uiVersion: ui.uiVersion,
    envLabel: ui.environmentLabel,
    hidden: ui.hideMenu,
    language: ui.language,
    nps: ui.nps,
    userData: auth.userData,
    pageTitle: ui.pageTitle,
    currentMfeState: mfeManager.currentMfeState,
    mfeStage: ui.mfeStage,
    tenant: tenant,
    userProfile: userProfile,
}))(LayoutComponent);
//# sourceMappingURL=index.js.map